const OVERRIDE_WIX_CODE_IDE = 'override-wix-code-ide';

export { OVERRIDE_WIX_CODE_IDE };
